import React from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Avatar, CardHeader } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function CardUser({ user }) {
  const classes = useStyles();

  return user ? (
    <Card className={classes.root} variant="outlined">
      <CardHeader avatar={<AccountCircleIcon />} title={user?.displayName} />
      <CardContent>
        <Typography component="p" variant="body2">
          <b>Email:</b> {user?.emailAddress}
          <br />
          <b>NetworkUser:</b> {user?.networkUser}
        </Typography>
      </CardContent>
    </Card>
  ) : (
    <></>
  );
}
